const roundOff = (
  numberToConvert: number = 0,
  numberOfPoints: number = 1
): number => parseFloat(numberToConvert.toFixed(numberOfPoints));

export { roundOff };
